import { recordClick } from './actions'

let scrollPercentiles = [25, 50, 75, 100]

/**
 * @param {number[] | null} [customScrollPercentiles]
 * @returns {TeardownFunction}
 */
export default (customScrollPercentiles = null) => {
  if (customScrollPercentiles) scrollPercentiles = customScrollPercentiles
  scrollPercentiles = sortArray(scrollPercentiles)

  window.addEventListener('scroll', handleScroll)

  return () => {
    window.removeEventListener('scroll', handleScroll)
  }
}

const handleScroll = () => {
  const scrollTop = window.scrollY
  const docHeight = document.body.clientHeight
  const winHeight = window.innerHeight
  const scrollPercent = (Math.round((scrollTop) / (docHeight - winHeight) * 100))
  scrollPercentiles = scrollPercentiles.filter(percentile => {
    if (scrollPercent >= percentile) {
      recordClick('Scroll', `${percentile}%`)
      return false
    }
    return true
  })
}

const sortArray = values => values.sort((a,b) => a - b)

